module.exports = __webpack_public_path__ + "img/cloud-slash.b6d6176f.svg";